var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { computed } from "mobx";
import { DocumentRetrievalLocationStatus } from "healthex-common/document.retrieval.dtos";
import { getObservableT } from "../Infra/i18next";
const t = getObservableT("patients");
export class DocumentRetrievalResultsFoundListViewModel {
    constructor(parentModel) {
        this.parentModel = parentModel;
    }
    get locationList() {
        let result;
        if (this.parentModel.isScreenshotMode && !this.parentModel.isPreview) {
            const needsAuth = this.parentModel.initialLocationsNeedingAuthentication;
            result = this.parentModel.locationList.map((location) => needsAuth.includes(location.key) ? { ...location, status: DocumentRetrievalLocationStatus.NEEDS_AUTH } : location);
        }
        else {
            result = this.parentModel.locationList;
        }
        result = result.slice().sort((a, b) => {
            function getPriority(location) {
                if (!!location.isExcluded ||
                    location.status === DocumentRetrievalLocationStatus.SKIPPED ||
                    location.status === DocumentRetrievalLocationStatus.NEEDS_AUTH) {
                    return 1;
                }
                return 0;
            }
            return getPriority(a) - getPriority(b);
        });
        return result;
    }
    get locationsCompleted() {
        return this.parentModel.locationsCompleted;
    }
    get isStatic() {
        return this.parentModel.uiState.isStatic;
    }
    get supportingText() {
        return t("Some of your providers require you to login to access your records.");
    }
    get buttonText() {
        return t("Continue");
    }
    get title() {
        return t("Records found!");
    }
    get providerText() {
        return t("Missing a provider? HealthEx can find most automatically, but some may not show up yet. You can add more after logging in or skipping the ones above.");
    }
    get animate() {
        return this.parentModel.animate;
    }
    async handleContinueClick() {
        if (!this.isStatic) {
            this.parentModel.continueToStartLoginCycle();
        }
        else {
            this.parentModel.uiState.hasCompletedStaticLoginCycle = true;
        }
    }
    shouldDelayLocation(location) {
        const isLoginRequired = location.status === DocumentRetrievalLocationStatus.NEEDS_AUTH || location.status === DocumentRetrievalLocationStatus.SKIPPED;
        return isLoginRequired && this.locationsCompleted.length > 0;
    }
}
__decorate([
    computed
], DocumentRetrievalResultsFoundListViewModel.prototype, "locationsCompleted", null);
__decorate([
    computed
], DocumentRetrievalResultsFoundListViewModel.prototype, "supportingText", null);
__decorate([
    computed
], DocumentRetrievalResultsFoundListViewModel.prototype, "buttonText", null);
__decorate([
    computed
], DocumentRetrievalResultsFoundListViewModel.prototype, "title", null);
__decorate([
    computed
], DocumentRetrievalResultsFoundListViewModel.prototype, "providerText", null);
__decorate([
    computed
], DocumentRetrievalResultsFoundListViewModel.prototype, "animate", null);
